export const GET_USER_INFO_FETCHING = "GET_USER_INFO_FETCHING";
export const GET_USER_INFO_DATA = "GET_USER_INFO_DATA";
export const GET_USER_INFO_FAILED = "GET_USER_INFO_FAILED";
export const Status = {
  Yes: "Y",
  No: "N",
  Wait: "W",
  Success: "S",
  Error: "E",
  Active: "A",
};

export const StatusCode = {
  UserNotFound: "888",
  DataNotFound: "404",
};

export const Language = {
  Thai: "th",
  English: "en",
};

export const BillingStatus = {
  Success: "S",
  Special: "Y",
  Reject: "R",
  Cancel: "N",
  All: "O",
};

export const QueueStatus = {
  Success: "S",
  Fail: "F",
  TechnicianSuccess: "TS",
  TechnicianFailed: "TF",
};

export const SuccessQueueStatus = [
  QueueStatus.Success,
  QueueStatus.Fail,
  QueueStatus.TechnicianFailed,
  QueueStatus.TechnicianSuccess,
];

export const QChannel = {
  DeliveryService: "DS",
  HomeRoute: "HRT",
};

export const MODE = {
  LOGIN: "LOGIN",
  RESET: "RESET",
};
